<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/fQUQwS/tc-custom/9780547545707.jpg?1704761434966" alt="This image is the cover for the book Third Class Superhero"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Third Class Superhero
      </h1>
      <p class="bookDescription body article font2">
        <b>“A compulsively readable collection” of short fiction from the author of <i>How to Live Safely in a Science Fictional Universe</i> (<i>Publishers Weekly</i>).</b><br/><br/> With deadpan humor and originality, Charles Yu spins Kafkaesque tales of modern identity and insecurity in this whip-smart debut. In <i>401(k)</i>, a couple living in the Luxury Car Commercial subdivision are disappointed when their exotic vacation turns into a Life Insurance/Asset Management pitch. The author struggles to write the definitive biography of his mother in <i>Autobiographical Raw Material Unsuitable for the Mining of Fiction</i>. And would-be superhero Moisture Man must come to terms with the darkness in his heart.<br/>  <br/> Throughout the collection, Yu’s characters run up against the limitations of their artificial story lines while tackling the terrifying aspects of existence: mothers, jobs, spouses, and perhaps most terrifying of all, the need to express feelings. Heartbreaking and hilarious, <i>Third Class Superhero </i>marked the debut of an author who has been a PEN award finalist, and whose novel <i>How to Live Safely in a Science Fictional Universe</i> was named one of <i>Time</i>’s best books of the year.<br/>  <br/> “The post-collegiate braininess of many of Yu’s stories is like the music of the Talking Heads, making the familiar seem off-kilter. . . . Takes a Kafkaesque turn in its comic examination of the essence of identity.” —<i>Kirkus Reviews</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Charles Yu
      </h2>
      
      <p class="authorDescription body article">Charles Yu is the author of <I>How to Live Safely</I><I>in a Science Fictional Universe</I>, which was named one of the best books of the year by <I>Time</I> magazine. He received the National Book Foundation&rsquo;s 5 Under 35 Award for his story collection <I>Third Class Superhero</I>, and was a finalist for the PEN Center USA Literary Award. Yu&rsquo;s work has been published in the<I> New York Times</I>, <I>Playboy</I>, and <I>Slate</I>, among other periodicals.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Houghton Mifflin Harcourt (www.hmhco.com)
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?579ae010